




































import { Component, Vue, Watch } from 'vue-property-decorator'
import store from '@/store'
import { Button, Checkbox, Icon } from '@alpha/ink'
import TabPanel from '@/components/TabPanel.vue'
import FullscreenModal from '@/components/Modal/FullscreenModal.vue'
import { TabRoute } from '@/types/frontend'
import { getQuestionOpenEnds, isOpenEnd } from '@/components/Survey/Utilities/SurveyUtilities'
import { Respondent, Response } from '@/store/modules/survey-store-module'
import router from '@/router'
import { getPagePosition } from '@/utilities/browser'

@Component({
  components: {
    Checkbox,
    Button,
    Icon,
    TabPanel,
    FullscreenModal
  }
})
export default class ResponseManagement extends Vue {
  responseRemovalMap: Record<string, boolean> = {}
  respondentRemovalMap: Record<string, boolean> = {}
  savedScrollPosition: { left: number, top: number } = { left: 0, top: 0 }
  lastResponseClicked: Response & {index: number} | null = null
  lastRespondentClicked: Respondent & {index: number} | null = null
  loading: boolean = false

  get subroutes (): TabRoute<ResponseManagement>[] {
    return [
      {
        name: 'by-question',
        displayName: 'By question'
      },
      {
        name: 'by-participant',
        displayName: 'By participant'
      }
    ]
  }

  get questions () {
    return store.getters.survey.questionsWithUnfilteredResponses.filter(question => {
      return isOpenEnd(question)
    })
  }

  get respondents () {
    return store.state.survey.respondents
  }

  created () {
    this.reset()
  }

  toggleRespondentRemoval (payload: { respondent: Respondent, shiftClick: boolean, index: number }) {
    if (payload.shiftClick && this.lastRespondentClicked) {
      this.handleRespondentShiftClick(payload)
    } else {
      this.$set(this.respondentRemovalMap, payload.respondent.id, !this.respondentRemovalMap[payload.respondent.id])
    }
    this.lastRespondentClicked = Object.assign(payload.respondent, { index: payload.index })
  }

  handleRespondentShiftClick (payload: { respondent: Respondent; shiftClick: boolean, index: number }) {
    if (!this.lastRespondentClicked) return
    const { firstIndex, lastIndex } = this.getClickRange(this.lastRespondentClicked.index, payload.index)
    const respondentsToToggle = this.respondents.slice(firstIndex, lastIndex)
    const respondentIds = respondentsToToggle.map(respondent => respondent.id)
    this.setAllRespondents(respondentIds, !this.respondentRemovalMap[payload.respondent.id])
  }

  toggleResponseRemoval (payload: { response: Response, shiftClick: boolean, index: number }) {
    if (payload.shiftClick && this.lastResponseClicked) {
      this.handleResponseShiftClick(payload)
    } else {
      this.$set(this.responseRemovalMap, payload.response.id, !this.responseRemovalMap[payload.response.id])
    }
    this.lastResponseClicked = Object.assign(payload.response, { index: payload.index })
  }

  handleResponseShiftClick (payload: { response: Response, shiftClick: boolean, index: number }) {
    if (!this.lastResponseClicked) return
    const { firstIndex, lastIndex } = this.getClickRange(this.lastResponseClicked.index, payload.index)

    const question = this.questions.find(question => question.id === payload.response.questionId)!
    const responses = getQuestionOpenEnds(question)
    const responsesToToggle = responses.slice(firstIndex, lastIndex)
    const responseIds = responsesToToggle.map(response => response.id)
    this.setAllResponses(responseIds, !this.responseRemovalMap[payload.response.id])
  }

  setAllResponses (responseIds: string[], show: boolean) {
    responseIds.forEach(id => {
      this.$set(this.responseRemovalMap, id, show)
    })
  }

  setAllRespondents (respondentIds: string[], show: boolean) {
    respondentIds.forEach(id => {
      this.$set(this.respondentRemovalMap, id, show)
    })
  }

  getClickRange (prevIndex: number, nextIndex: number) {
    let firstIndex, lastIndex
    if (nextIndex < prevIndex) { // shift clicking down
      firstIndex = nextIndex
      lastIndex = prevIndex + 1
    } else { // shift clicking up
      firstIndex = prevIndex
      lastIndex = nextIndex + 1
    }
    return { firstIndex, lastIndex }
  }

  reset () {
    this.responseRemovalMap = { ...store.state.survey.responseRemovalMap }
    this.respondentRemovalMap = { ...store.state.survey.respondentRemovalMap }
  }

  close () {
    this.reset()
    this.$router.push({
      name: 'test'
    })
  }

  @Watch('$route', { immediate: true, deep: true })
  updateScrollPosition (newRoute: typeof router.currentRoute, oldRoute?: typeof router.currentRoute) {
    if (oldRoute?.name === 'by-question') {
      const container = document.querySelector('.overlay')
      this.savedScrollPosition = getPagePosition(container)
    }
    if (newRoute.name === 'by-question') {
      if (!oldRoute) return
      const { top } = this.savedScrollPosition
      const container = document.querySelector('.overlay')
      if (!container) return console.error('Missing required selector for scroll container')
      setTimeout(() => {
        container.scrollTop = top
      }, 0)
    }
  }

  async updateRespondentList () {
    const { responseRemovalMap, respondentRemovalMap } = this
    this.loading = true
    await store.dispatch.survey.updateRespondentList({
      responseRemovalMap,
      respondentRemovalMap
    })
    window.scrollTo({ top: 0 })
    this.loading = false
    this.close()
  }
}

